export enum ErrorCode
{
    GeneralError = "GeneralError",
    GeneralUnauthorizedError = "GeneralUnauthorizedError",
    GeneralBadRequestError = "GeneralBadRequestError",
    GeneralNotFoundError = "GeneralNotFoundError",
    GeneralForbiddenError = "GeneralForbiddenError",
    GeneralConflictError = "GeneralConflictError",
    GeneralUnProcessableEntityError = "GeneralUnProcessableEntityError",
    GeneralTooManyRequestsError = "GeneralTooManyRequestsError",
    NullReference = "NullReference",
    ArgumentIsNull = "ArgumentIsNull",
    ArgumentIsOutOfRange = "ArgumentIsOutOfRange",
    ArgumentIsInvalidEnum = "ArgumentIsInvalidEnum",
    AuthenticationTokenInvalid = "AuthenticationTokenInvalid",
    FileNotFound = "FileNotFound",
    MethodNotSupported = "MethodNotSupported",
    MethodNotImplemented = "MethodNotImplemented",
    SessionNotFound = "SessionNotFound",
    MissingPagingParameter = "MissingPagingParameter",
    NoUserIdGiven = "NoUserIdGiven",
    NoCompanyIdGiven = "NoCompanyIdGiven",
    TimeframeEndBeforeStart = "TimeframeEndBeforeStart",
    ModelValidationFailed = "ModelValidationFailed",
    UserNotFound = "UserNotFound",
    UserIdNotAValidGuid = "UserIdNotAValidGuid",
    UserEmailAlreadyTaken = "UserEmailAlreadyTaken",
    UserEmailFailedToChange = "UserEmailFailedToChange",
    UserNoCompanyAssigned = "UserNoCompanyAssigned",
    UserPasswordSetFailed = "UserPasswordSetFailed",
    UserPasswordChangeFailed = "UserPasswordChangeFailed",
    EmployeeUserNotFound = "EmployeeUserNotFound",
    EmployeeNumberIsDuplicate = "EmployeeNumberIsDuplicate",
    EmployeeAlreadyRegistered = "EmployeeAlreadyRegistered",
    EmployeeRegistrationError = "EmployeeRegistrationError",
    EmployeeEmailCanNotBeSet = "EmployeeEmailCanNotBeSet",
    EmployeeIsNotPartOfCompany = "EmployeeIsNotPartOfCompany",
    ManagerUserNotFound = "ManagerUserNotFound",
    ManagerUserCreationFailed = "ManagerUserCreationFailed",
    CompanyNotFound = "CompanyNotFound",
    ServiceModuleNotFound = "ServiceModuleNotFound",
    ServiceModuleWrongKind = "ServiceModuleWrongKind",
    ServiceModuleModelWrongKind = "ServiceModuleModelWrongKind",
    AbsenceOverlappingFound = "AbsenceOverlappingFound",
    AbsenceAlreadyApproved = "AbsenceAlreadyApproved",
    AbsenceNotFound = "AbsenceNotFound",
    VacationQuotaNotEnoughRemainingVacationDays = "VacationQuotaNotEnoughRemainingVacationDays",
    VacationQuotaUserIsNeitherManagerNorTheGivenEmployee = "VacationQuotaUserIsNeitherManagerNorTheGivenEmployee",
    VacationQuotaOverlappingFound = "VacationQuotaOverlappingFound",
    VacationQuotaNotFound = "VacationQuotaNotFound",
    TimesheetInvalid = "TimesheetInvalid",
    TimeQuotaInvalid = "TimeQuotaInvalid",
    TimeQuotaUserIsNeitherManagerNorTheGivenEmployee = "TimeQuotaUserIsNeitherManagerNorTheGivenEmployee",
    TimeQuotaNotFound = "TimeQuotaNotFound",
    ActionModuleNotFound = "ActionModuleNotFound",
    ActionModuleTriggerNotFound = "ActionModuleTriggerNotFound",
    ActionModuleTriggerOutOfTimeBounds = "ActionModuleTriggerOutOfTimeBounds",
    ActionModuleSchedulingIsNull = "ActionModuleSchedulingIsNull",
    ActionModuleNotPartOfCompany = "ActionModuleNotPartOfCompany",
    ActionModuleEmployeeNotPermitted = "ActionModuleEmployeeNotPermitted",
    ActionModuleSchedulingStrategyWrongKind = "ActionModuleSchedulingStrategyWrongKind",
    ActionModuleChecklistUpdateFailed = "ActionModuleChecklistUpdateFailed",
    ActionModuleBonusActionFinishFailed = "ActionModuleBonusActionFinishFailed",
    ActionModuleNotEditable = "ActionModuleNotEditable",
    ActionModuleNameAlreadyExists = "ActionModuleNameAlreadyExists",
    ActionModuleSchedulingImpossible = "ActionModuleSchedulingImpossible",
    GroupContainsComma = "GroupContainsComma",
    GroupNotFound = "GroupNotFound",
    AuthorizationFailed = "AuthorizationFailed",
    WalletTransactionAlreadyExists = "WalletTransactionAlreadyExists",
    WalletTransactionAlreadyBooked = "WalletTransactionAlreadyBooked",
    WalletTransactionNotFound = "WalletTransactionNotFound",
    WalletNotFound = "WalletNotFound",
    WalletCanNotAddEntity = "WalletCanNotAddEntity",
    WalletMultipleWalletsFound = "WalletMultipleWalletsFound",
    WalletTypeNotFound = "WalletTypeNotFound",
    WalletTypeAlreadyHasFallback = "WalletTypeAlreadyHasFallback",
    WalletTypeIsFallbackCannotUnset = "WalletTypeIsFallbackCannotUnset",
    WalletTypeCannotDeleteFallback = "WalletTypeCannotDeleteFallback",
    WalletTypeHasTransactions = "WalletTypeHasTransactions",
    VoucherBoughtMoreThanAllowed = "VoucherBoughtMoreThanAllowed",
    VoucherNoProductFound = "VoucherNoProductFound",
    VoucherNoOwner = "VoucherNoOwner",
    VoucherInvalidOwner = "VoucherInvalidOwner",
    VoucherUnavailable = "VoucherUnavailable",
    VoucherTypeDoesNotExist = "VoucherTypeDoesNotExist",
    VoucherNoOrderFound = "VoucherNoOrderFound",
    VoucherCanNotCreateOrder = "VoucherCanNotCreateOrder",
    VoucherOrderAlreadyInProgress = "VoucherOrderAlreadyInProgress",
    VoucherNoCatalogueFound = "VoucherNoCatalogueFound",
    VoucherNoClientBinding = "VoucherNoClientBinding",
    ShopModuleNotFound = "ShopModuleNotFound",
    ShopModuleNoGroupAssigned = "ShopModuleNoGroupAssigned",
    ShopModuleNoEmployeeAssigned = "ShopModuleNoEmployeeAssigned",
    ShopModuleNoCompanyAssigned = "ShopModuleNoCompanyAssigned",
    AdminUserCreationFailed = "AdminUserCreationFailed",
    IncentivationImportFailed = "IncentivationImportFailed",
    IncentivationImportInvalid = "IncentivationImportInvalid",
    IncentivationCompletionError = "IncentivationCompletionError",
    TimetrackingProjectDuplicateName = "TimetrackingProjectDuplicateName",
    TimetrackingProjectNotFound = "TimetrackingProjectNotFound",
    StatusLevelRangeOverlap = "StatusLevelRangeOverlap",
    StatusLevelIsCurrentStatus = "StatusLevelIsCurrentStatus",
    StatusServiceModuleScheduleInvalid = "StatusServiceModuleScheduleInvalid",
    StatusLevelNotFound = "StatusLevelNotFound"
}

export function localizationKeyOf(code: ErrorCode): string {
    const lowerCamelCase = code[0].toLowerCase() + code.substring(1);
    return `errors.${lowerCamelCase}`;
}